

interface LocationConsentModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export default function LocationConsentModal({ isOpen, onAccept, onDecline }: LocationConsentModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface border border-border rounded-lg max-w-md w-full p-6">
        <div className="text-center mb-6">
          <div className="text-4xl mb-2">📍</div>
          <h3 className="text-xl font-semibold text-text-primary mb-2">
            Location Permission Required
          </h3>
        </div>

        <div className="space-y-4 text-text-secondary mb-6">
          <p>
            To check in to this event, we need to access your location to verify you are at the event location.
          </p>
          
          <div className="bg-surface-secondary rounded-lg p-4">
            <h4 className="font-medium text-text-primary mb-2">How we use your location:</h4>
            <ul className="text-sm space-y-1 list-disc list-inside">
              <li>Verify you are within the event check-in radius</li>
              <li>Store check-in location for event attendance records</li>
              <li>Location data is retained for 12 months then automatically deleted</li>
              <li>Only event organizers can see attendance records</li>
            </ul>
          </div>

          <p className="text-sm text-text-muted">
            You can review our privacy policy in Settings for more details about data handling.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onDecline}
            className="flex-1 px-4 py-2 text-text-secondary border border-border rounded-lg hover:bg-surface-secondary transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onAccept}
            className="flex-1 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            Allow Location Access
          </button>
        </div>
      </div>
    </div>
  );
}